import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { CardImg } from 'reactstrap';
import './HeroTextNarrow.css';

// https://getbootstrap.com/docs/4.3/utilities/colors/#background-color

const HeroTextNarrow = (props) => {
    return (
        <Container fluid className='hero-background text-center border border-secondary'>
            <h1 className='text-center text-uppercase '>New This Autumn</h1>
            <Row className=''>
                <Col md={3} sm={6} xm={12} className='align-self-center'><CardImg className='img-apparel' src='images/apparel/uglyBROS.svg' alt='uglyBROS' /></Col>
                <Col md={3} sm={6} xm={12} className='align-self-center'><CardImg className='img-apparel' src='images/apparel/MotoGirl.svg' alt='MotoGirl' /></Col>
                <Col md={3} sm={6} xm={12} className='align-self-center'><CardImg className='img-apparel' src='images/apparel/Spidi.svg' alt='Spidi' /></Col>
                <Col md={3} sm={6} xm={12} className='align-self-center'><CardImg className='img-apparel' src='images/apparel/Kriega.svg' alt='Kriega' /></Col>
            </Row>
        </Container>
    )
};

export default HeroTextNarrow;


// WEBPACK FOOTER //
// ./src/components/HeroText/HeroTextNarrow.js